/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleTypeCreate
 */
export interface VehicleTypeCreate {
    /**
     * 
     * @type {string}
     * @memberof VehicleTypeCreate
     */
    label: string;
}

/**
 * Check if a given object implements the VehicleTypeCreate interface.
 */
export function instanceOfVehicleTypeCreate(value: object): value is VehicleTypeCreate {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function VehicleTypeCreateFromJSON(json: any): VehicleTypeCreate {
    return VehicleTypeCreateFromJSONTyped(json, false);
}

export function VehicleTypeCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleTypeCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function VehicleTypeCreateToJSON(json: any): VehicleTypeCreate {
    return VehicleTypeCreateToJSONTyped(json, false);
}

export function VehicleTypeCreateToJSONTyped(value?: VehicleTypeCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

